import { render, staticRenderFns } from "./OrderFilingTaxUpdateModel.vue?vue&type=template&id=305abda4&scoped=true"
import script from "./OrderFilingTaxUpdateModel.vue?vue&type=script&lang=js"
export * from "./OrderFilingTaxUpdateModel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305abda4",
  null
  
)

export default component.exports